import React from 'react'
import { Modal, Button } from 'react-bootstrap'

import SimpleMDE from '../lib/SimpleMDE'

type Props = {
  onHide: () => void,
  onChange: (string, any) => void,
  initialValue: string,
  label: string,
}

const ModalEditor = (
  {
    onHide, 
    onChange, 
    initialValue, 
    label
  } = Props
) => (
  <Modal 
    onHide={onHide}
    show 
    bsSize="large"
  >
    <Modal.Header>
      <Modal.Title>
        {label}
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <SimpleMDE 
        options={{
          initialValue: initialValue,
          spellChecker: false, 
          autofocus: true, 
        }}
        onChange={text => onChange(text)}
      />
    </Modal.Body>
    <Modal.Footer>
      <Button bsStyle="success" onClick={onHide}>OK</Button>
    </Modal.Footer>
  </Modal>
)

export default ModalEditor

